<div class="widget-linking-group-picker" (click)="openDropdownMenu()">
  @if (selectedLinkingGroup.id === WidgetLinkingGroupId.NONE) {
    <svg
      class="widget-linking-group-picker_icon -selected">
      <use xlink:href="#chain"></use>
    </svg>
  }

  @if (selectedLinkingGroup.id !== WidgetLinkingGroupId.NONE) {
    <div
      ngClass="{{selectedLinkingGroup.className}}"
      class="widget-linking-group-picker_css-icon -selected">
    </div>
  }
</div>
